import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const nav = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch { /* noop */ }
  };
  useEffect(() => { load(); }, []);

  const open = async (n) => {
    if (!n.read) {
      try { await api.post(`/notifications/${n.id}/read`); } catch { /* noop */ }
    }
    if (n.link) nav(n.link);
  };
  const markAll = async () => {
    await api.post("/notifications/read-all");
    setItems(items.map((i) => ({ ...i, read: true })));
    setUnread(0);
    toast.success("All marked as read");
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-end justify-between">
          <div>
            <div className="label-mystic">Activity</div>
            <h1 className="font-serif text-5xl mt-2">Notifications</h1>
          </div>
          {unread > 0 && (
            <button onClick={markAll} className="text-xs text-secondary hover:text-secondary/80 uppercase tracking-wider" data-testid="notifications-mark-all">
              Mark all read
            </button>
          )}
        </div>
        <div className="parchment divide-y divide-secondary/15" data-testid="notifications-list">
          {items.length === 0 ? (
            <div className="p-12 text-center text-foreground/50 italic">No notifications yet</div>
          ) : items.map((n) => (
            <button key={n.id} onClick={() => open(n)}
              className={`w-full text-left p-5 hover:bg-secondary/5 ${!n.read ? "bg-primary/5" : ""}`}
              data-testid={`notification-${n.id}`}>
              <div className="flex items-start gap-3">
                {!n.read && <span className="w-2 h-2 mt-2 bg-primary rounded-full flex-shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="font-serif text-lg">{n.title}</div>
                  {n.body && <div className="text-sm text-foreground/75 mt-1">{n.body}</div>}
                  <div className="label-mystic mt-2">{new Date(n.createdAt).toLocaleString()}</div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
}
